import React from "react";

const AppLink = ( props ) =>
{

    const height = props.height === undefined || props.height === null ? '60px' : props.height;

    const width = props.width === undefined || props.width === null ? '60px' : props.width;

    const hasLink = props.link !== undefined && props.link !== null;

    const hasOnClick = props.onClick !== undefined && props.onClick !== null;

    const onClick = (event) =>
    {
        // A link takes precedence: let the anchor navigate and ignore any onClick.
        if (hasLink)
        {
            return;
        }

        if (hasOnClick)
        {
            event.preventDefault();

            props.onClick(event);
        }
    }

    return (
        <div className='icon-content'>
            <div className='selection-layout'>
                <a href={hasLink ? props.link : undefined} target={props.target} onClick={onClick}>{props.title}
                    <div>
                        <img alt='image' height={height} width={width} src={props.imageSrc} style={{alignSelf: "center"}}/>
                    </div>
                </a>
            </div>
        </div>
    )
}

export default AppLink ;